import {
  sendOtpResponse,
  verifyOtpResponse,
} from "@services/models/Authentication/Authentication";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class AuthenticationApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient({
      notifyErrors: false,
      handleUnauthorized: false,
    });
  }

  public async sendOtp(email: string): Promise<sendOtpResponse> {
    try {
      // Construct the URL with the email parameter
      const response = await this.api.get(
        `/adminPanel/sendOTP?email=${encodeURIComponent(email)}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async verifyOtp(
    email: string,
    code: string,
    csrfToken: string
  ): Promise<verifyOtpResponse> {
    try {
      const response = await this.api.post(
        `/adminPanel/verifyOTP`,
        {
          email,
          code,
        },
        {
          headers: {
            csrftoken: csrfToken,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const authenticationApiService = new AuthenticationApiService();
